"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_utils_1 = require("@8x8/oxygen-utils");
const ArrowDownIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/ArrowDownIcon"));
const ArrowUpIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/ArrowUpIcon"));
const DropdownButtonComponent = styled_components_1.default.button `
  display: flex;
  justify-content: space-between;
  ${({ $fullWidth }) => $fullWidth && 'width: 100%;'}
  box-sizing: border-box;
  gap: 8px;
  ${({ size, theme }) => {
    if (size === 'large') {
        return { ...theme.bodyBold02 };
    }
    if (size === 'small') {
        return { ...theme.labelBold01 };
    }
    return { ...theme.bodyBold01 };
}}
  color: ${({ theme }) => theme.textColor01};
  background: ${({ theme }) => theme.ui06};
  padding: 11px 15px;
  border: 1px solid ${({ theme }) => theme.ui06};
  border-radius: 6px;
  cursor: pointer;
  outline: none;
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.focus01};
    outline-offset: -2px;
  }

  ${({ $isActive, theme }) => $isActive && `border-color: ${theme.active02};`}
  ${({ 'aria-disabled': ariaDisabled, theme }) => {
    if (ariaDisabled) {
        return `
    color: ${theme.disabled04};
    cursor: not-allowed;
  `;
    }
    return `&:hover {
      border-color: ${theme.active02};
    }`;
}}
`;
const iconSizeMap = {
    large: 24,
    medium: 20,
    small: 16,
};
exports.DropdownButton = (0, react_1.forwardRef)(function DropdownButton({ children, size = 'medium', isActive = false, isDisabled = false, fullWidth = false, testId = 'DROPDOWN_BUTTON', onClick, onKeyDown, ...rest }, ref) {
    const { theme } = (0, oxygen_config_1.useOxygen)();
    const handleOnClick = (ev) => {
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onClick) {
            onClick(ev);
        }
    };
    const handleOnKeyDown = (ev) => {
        if (((0, oxygen_utils_1.isSpaceEvent)(ev) || (0, oxygen_utils_1.isEnterEvent)(ev)) && isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onKeyDown) {
            onKeyDown(ev);
        }
    };
    const iconProps = {
        size: iconSizeMap[size],
        ...(isDisabled && { color: theme.disabled04 }),
    };
    const buttonProps = {
        ...(isDisabled && { 'aria-disabled': true }),
    };
    return (react_1.default.createElement(DropdownButtonComponent, { size: size, "$fullWidth": fullWidth, ref: ref, "$isActive": isActive, onClick: handleOnClick, onKeyDown: handleOnKeyDown, ...buttonProps, ...(0, oxygen_config_1.getTestAttributes)(testId), ...rest },
        children,
        isActive ? (react_1.default.createElement(ArrowUpIcon_1.default, { ...iconProps })) : (react_1.default.createElement(ArrowDownIcon_1.default, { ...iconProps }))));
});
